import { render } from "./TestTalkingText.vue?vue&type=template&id=036e5d68&scoped=true"
import script from "./TestTalkingText.vue?vue&type=script&lang=js"
export * from "./TestTalkingText.vue?vue&type=script&lang=js"

import "./TestTalkingText.vue?vue&type=style&index=0&id=036e5d68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-036e5d68"]])

export default __exports__